import { z } from "zod";
export const PatientSearchResultSchema = z
    .object({
    createdAt: z.coerce.date(),
    id: z.uuid(),
    nhsNumber: z.string().nullable(),
    patientId: z.string().nullable(),
    searchId: z.uuid(),
    userId: z.uuid(),
})
    .brand();
//# sourceMappingURL=patientSearchV2.js.map